<nav class="folder-path" #folderPath role="navigation" aria-label="Folder path">
  @if (showMenu) {
    <div class="active">
      <button mat-button [matMenuTriggerFor]="folderMenu" class="backlink">
        <mat-icon svgIcon="more-horizontal"></mat-icon>
      </button>
      <mat-menu #folderMenu="matMenu">
        @for (folder of hiddenFolders; track folder) {
          <button
            mat-menu-item
            (click)="clickFolder(folder.path || folder.folderId)"
          >
            {{ folder.name }}
          </button>
        }
      </mat-menu>
    </div>
  }
  @for (
    folder of visibleFolders;
    track folder.folderId ?? folder.path;
    let last = $last;
    let i = $index
  ) {
    @if (i > 0) {
      <div class="separator" aria-hidden="true">
        <mat-icon svgIcon="chevron-right" aria-hidden="true"></mat-icon>
      </div>
    }
    <div
      class="active"
      [rvDroppableItem]="{ id: folder.folderId, name: folder.path }"
      [dropNotAllowed]="last"
    >
      @if (
        !last && (folder.path !== undefined || folder.folderId !== undefined)
      ) {
        <button
          mat-button
          class="backlink"
          (click)="clickFolder(folder.path || folder.folderId)"
          (keydown.enter)="clickFolder(folder.path || folder.folderId)"
          [disabled]="
            folder.path === undefined && folder.folderId === undefined
          "
          [attr.aria-label]="'Navigate to ' + folder.name + ' folder'"
        >
          {{ folder.name }}
        </button>
      } @else {
        <span class="tw-font-semibold tw-px-2">{{ folder.name }}</span>
      }
    </div>
  }
</nav>
